/**
 * Informations générales du site : une seule source pour l'en-tête, le pied de page, les données structurées (JSON-LD),
 * la page « Mentions légales » et le prérendu. Fichier en CommonJS pour être lu aussi par prerender.js (Node).
 */
module.exports = {
    url: 'https://citrondigital.fr',
    name: 'Citron Digital',
    product: 'Gestionnaire Citron',
    productUrl: 'https://gestionnaire.citrondigital.fr/',
    tagline: 'Logiciel de devis, factures et facturation électronique',
    email: 'contact@citrondigital.fr',
    phone: '06 14 85 18 19',
    phoneIntl: '+33614851819',
    linkedin: 'https://www.linkedin.com/in/franck-besson-fr/',
    locale: 'fr_FR',
    area: 'Toulouse',
    foundingDate: '2020-07',
    author: {
        name: 'Franck Besson',
        path: '/portfolio',
        jobTitle: 'Développeur et fondateur de Citron Digital'
    },
    // Image de partage par défaut (réseaux sociaux, Google Discover), 1200 x 630
    ogImage: '/img/og/default.jpg',
    logo: '/logo.png',
    // Mentions légales : une ligne n'est affichée que lorsqu'elle est renseignée ici
    legal: {
        publisher: 'Franck Besson, à l\'enseigne Citron Digital',
        status: '',               // ex. « Entrepreneur individuel (micro-entrepreneur) »
        siret: '',                // 14 chiffres
        address: '',              // adresse professionnelle
        vatNumber: '',            // numéro de TVA intracommunautaire, ou mention de franchise en base
        publicationDirector: 'Franck Besson',
        host: {
            name: '',             // ex. OVH SAS
            address: ''
        }
    }
};
